
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#1E1E1E"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.52 2.122a1 1 0 011.02.037l14 9a1 1 0 010 1.682l-14 9A1 1 0 014 21V3a1 1 0 01.52-.878zM6 4.832v14.336L17.15 12 6 4.832z"}})])
          )
        }
      }
    